import React from 'react';
import { cn } from 'shared/lib/cn';

export type NumFieldProps = {
  value: number | string;
  onChange: (raw: string) => void;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  min?: number;
  max?: number;
  step?: number | string;
  unit?: string;
  ariaLabel: string;
  disabled?: boolean;
  id?: string;
  className?: string;
};

/** Number entry. Deliberately does NOT clamp on keystroke — clamping made a
 *  two-digit count untypeable (CONF-181); callers clamp on blur or on commit
 *  (useNumberDraft, CONF-217, is the shared way to do that). */
export function NumField({ value, onChange, onBlur, onKeyDown, min, max, step = 1, unit, ariaLabel, disabled, id, className }: NumFieldProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <input
        id={id}
        type="number"
        inputMode="decimal"
        aria-label={ariaLabel}
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        className="h-9 w-full rounded-[var(--radius-2)] border border-hairline/30 bg-surface-overlay px-3 font-code text-sm text-ink focus:outline-none focus:ring-2 focus:ring-brand/60 disabled:opacity-50"
      />
      {unit && <span className="shrink-0 font-code text-xs text-ink-muted">{unit}</span>}
    </div>
  );
}
